import { createAction, handleActions } from 'redux-actions';
import { _getActivePetTypesList, _getAllActiveVenuesList, _getAllActiveAttendantList, _getPetTypInfoByID, _createNewService, _getServicesList, _editService, _getServiceDetails, _deleteService, _getServicesByRetailers } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  pet_types: { loading: false, response: [], hasError: false, error: {} },
  venues: { loading: false, response: [], hasError: false, error: {} },
  attendant_list: { loading: false, response: [], hasError: false, error: {} },
  selected_pet_type_info: { loading: false, response: [], hasError: false, error: {} },
  add_service: { loading: false, response: [], hasError: false, error: {} },
  services_list: { loading: false, response: [], hasError: false, error: {} },
  edit_service: { loading: false, response: [], hasError: false, error: {} },
  service_details: { loading: false, response: [], hasError: false, error: {} },
  delete_service: { loading: false, response: [], hasError: false, error: {} },
  service_by_retailer:{ loading: false, response: [], hasError: false, error: {} },
};

export const getActivePetTypesListStart = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST);
export const getActivePetTypesListSuccess = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS, response => response);
export const getActivePetTypesListError = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR, error => error);

export const getActivePetTypesList = (page = '', pageSize) => (dispatch) => {
  dispatch(getActivePetTypesListStart());
  return _getActivePetTypesList(page, pageSize).then((response) => {
    dispatch(getActivePetTypesListSuccess(response));
  }).catch((error) => {
    dispatch(getActivePetTypesListError(error));
  });
};

export const getAllActiveVenuesListStart = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST);
export const getAllActiveVenuesListSuccess = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_SUCCESS, response => response);
export const getAllActiveVenuesListError = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_ERROR, error => error);

export const getAllActiveVenuesList = (filter = '') => (dispatch) => {
  dispatch(getAllActiveVenuesListStart());
  return _getAllActiveVenuesList(filter).then((response) => {
    dispatch(getAllActiveVenuesListSuccess(response));
  }).catch((error) => {
    dispatch(getAllActiveVenuesListError(error));
  });
};

export const getAllActiveAttendantListStart = createAction(ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST);
export const getAllActiveAttendantListSuccess = createAction(ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST_SUCCESS, response => response);
export const getAllActiveAttendantListError = createAction(ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST_ERROR, error => error);

export const getAllActiveAttendantList = (filter = '') => (dispatch) => {
  dispatch(getAllActiveAttendantListStart());
  return _getAllActiveAttendantList(filter).then((response) => {
    dispatch(getAllActiveAttendantListSuccess(response));
  }).catch((error) => {
    dispatch(getAllActiveAttendantListError(error));
  });
};

export const getPetTypeDetailsStart = createAction(ActionTypes.GET_SELECTED_PET_TYPE_DETAILS);
export const getPetTypeDetailsSuccess = createAction(ActionTypes.GET_SELECTED_PET_TYPE_DETAILS_SUCCESS, response => response);
export const getPetTypeDetailsError = createAction(ActionTypes.GET_SELECTED_PET_TYPE_DETAILS_ERROR, error => error);

export const getPetTypeDetails = (id) => (dispatch) => {
  dispatch(getPetTypeDetailsStart());
  return _getPetTypInfoByID(id).then((response) => {
    dispatch(getPetTypeDetailsSuccess(response));
  }).catch((error) => {
    dispatch(getPetTypeDetailsError(error));
  });
};

export const createNewServiceStart = createAction(ActionTypes.CREATE_NEW_SERVICE);
export const createNewServiceSuccess = createAction(ActionTypes.CREATE_NEW_SERVICE_SUCCESS, response => response);
export const createNewServiceError = createAction(ActionTypes.CREATE_NEW_SERVICE_ERROR, error => error);

export const createNewService = (data) => (dispatch) => {
  dispatch(createNewServiceStart());
  return _createNewService(data).then((response) => {
    dispatch(createNewServiceSuccess(response));
  }).catch((error) => {
    dispatch(createNewServiceError(error));
  });
};

export const editServiceStart = createAction(ActionTypes.EDIT_SERVICE);
export const editServiceSuccess = createAction(ActionTypes.EDIT_SERVICE_SUCCESS, response => response);
export const editServiceError = createAction(ActionTypes.EDIT_SERVICE_ERROR, error => error);

export const editService = (data) => (dispatch) => {
  dispatch(editServiceStart());
  return _editService(data).then((response) => {
    dispatch(editServiceSuccess(response));
  }).catch((error) => {
    dispatch(editServiceError(error));
  });
};

export const getServicesListStart = createAction(ActionTypes.GET_SERVICES_LIST);
export const getServicesListSuccess = createAction(ActionTypes.GET_SERVICES_LIST_SUCCESS, response => response);
export const getServicesListError = createAction(ActionTypes.GET_SERVICES_LIST_ERROR, error => error);

export const getServicesList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getServicesListStart());
  return _getServicesList(page, pageSize, searchQuery).then((response) => {
    dispatch(getServicesListSuccess(response));
  }).catch((error) => {
    dispatch(getServicesListError(error));
  });
};

export const getServiceDetailsStart = createAction(ActionTypes.GET_SERVICE_DETAILS);
export const getServiceDetailsSuccess = createAction(ActionTypes.GET_SERVICE_DETAILS_SUCCESS, response => response);
export const getServiceDetailsError = createAction(ActionTypes.GET_SERVICE_DETAILS_ERROR, error => error);

export const getServiceDetails = (id) => (dispatch) => {
  dispatch(getServiceDetailsStart());
  return _getServiceDetails(id).then((response) => {
    dispatch(getServiceDetailsSuccess(response));
  }).catch((error) => {
    dispatch(getServiceDetailsError(error));
  });
};

export const deleteServiceStart = createAction(ActionTypes.DELETE_SERVICE);
export const deleteServiceSuccess = createAction(ActionTypes.DELETE_SERVICE_SUCCESS, response => response);
export const deleteServiceError = createAction(ActionTypes.DELETE_SERVICE_ERROR, error => error);

export const deleteService = (id) => (dispatch) => {
  dispatch(deleteServiceStart());
  return _deleteService(id).then((response) => {
    dispatch(deleteServiceSuccess(response));
  }).catch((error) => {
    dispatch(deleteServiceError(error));
  });
};


export const getServiceByRetailerStart = createAction(ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER);
export const getServiceByRetailerSuccess = createAction(ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER_SUCCESS, response => response);
export const getServiceByRetailerError = createAction(ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER_ERROR, error => error);

export const getServiceByRetailer = (pageNo, pageSize, inputValue) => (dispatch) => {
  dispatch( getServiceByRetailerStart());
  return _getServicesByRetailers(pageNo, pageSize, inputValue).then((response) => {
    dispatch(getServiceByRetailerSuccess(response));
  }).catch((error) => {
    dispatch( getServiceByRetailerError(error));
  });
};



const reducer = handleActions({

//SERVICES BY RETAILER
[ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER]: (state) => ({
  ...state,service_by_retailer: {
    ...state.service_by_retailer,
    loading: true, hasError: false, error: {}
  }
}),
[ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER_SUCCESS]: (state, action) => ({
  ...state,
  service_by_retailer: {
    ...state.service_by_retailer,
    response: action.payload, loading: false, hasError: false, error: {}
  }
}),
[ActionTypes.GET_SERVICE_DETAILS_BY_RETAILER_ERROR]: (state, action) => ({
  ...state,
  service_by_retailer: {
    ...state.service_by_retailer,
    error: action.payload, loading: false, hasError: true, response: {}
  }
}),



  //ACTIVE_PET_TYPES_LIST
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST]: (state) => ({
    ...state, pet_types: {
      ...state.pet_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ACTIVE_VENUES_LIST
  [ActionTypes.GET_ALL_ACTIVE_VENUES_LIST]: (state) => ({
    ...state, venues: {
      ...state.venues,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    venues: {
      ...state.venues,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_ERROR]: (state, action) => ({
    ...state,
    venues: {
      ...state.venues,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ACTIVE_VENUES_LIST
  [ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST]: (state) => ({
    ...state, attendant_list: {
      ...state.attendant_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST_SUCCESS]: (state, action) => ({
    ...state,
    attendant_list: {
      ...state.veattendant_listnues,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ALL_ACTIVE_ATTENDANT_LIST_ERROR]: (state, action) => ({
    ...state,
    attendant_list: {
      ...state.attendant_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //PET_TYPE_DETAILS
  [ActionTypes.GET_SELECTED_PET_TYPE_DETAILS]: (state) => ({
    ...state, selected_pet_type_info: {
      ...state.selected_pet_type_info,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SELECTED_PET_TYPE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    selected_pet_type_info: {
      ...state.veselected_pet_type_infonues,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SELECTED_PET_TYPE_DETAILS_ERROR]: (state, action) => ({
    ...state,
    selected_pet_type_info: {
      ...state.selected_pet_type_info,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //CREATE_SERVICE
  [ActionTypes.CREATE_NEW_SERVICE]: (state) => ({
    ...state, add_service: {
      ...state.add_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.CREATE_NEW_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    add_service: {
      ...state.add_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.CREATE_NEW_SERVICE_ERROR]: (state, action) => ({
    ...state,
    add_service: {
      ...state.add_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_SERVICE
  [ActionTypes.EDIT_SERVICE]: (state) => ({
    ...state, edit_service: {
      ...state.edit_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    edit_service: {
      ...state.edit_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SERVICE_ERROR]: (state, action) => ({
    ...state,
    edit_service: {
      ...state.edit_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //SERVICES_LIST
  [ActionTypes.GET_SERVICES_LIST]: (state) => ({
    ...state, services_list: {
      ...state.services_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    services_list: {
      ...state.services_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICES_LIST_ERROR]: (state, action) => ({
    ...state,
    services_list: {
      ...state.services_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //SERVICE_DETAILS
  [ActionTypes.GET_SERVICE_DETAILS]: (state) => ({
    ...state, service_details: {
      ...state.service_details,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    service_details: {
      ...state.service_details,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_DETAILS_ERROR]: (state, action) => ({
    ...state,
    service_details: {
      ...state.service_details,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //DELETE_SERVICE
  [ActionTypes.DELETE_SERVICE]: (state) => ({
    ...state, delete_service: {
      ...state.delete_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    delete_service: {
      ...state.delete_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_SERVICE_ERROR]: (state, action) => ({
    ...state,
    delete_service: {
      ...state.delete_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;